<template>

  <div class="akl">
    <div class="bod-view-txt">
      <!-- 제휴카드 프로모션(퀴즈응모) 공지 시작 -->
      <div class="wrapper-memb-join">
        <div class="os_noticeRes quiz_wrap" style="background:#defcff;">
          <div class="osResHeader padTXM padBXX">

            <div class="widM txtC">
              <img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/akl_common/quizPromo_tit.png" alt="퀴즈 풀고, 스타벅스 커피 받자! 암웨이-현대카드M Edition2 새로운 플레이트 출시 기념 퀴즈 이벤트"
                style="max-width:505px; width:80%;">
            </div>
          </div>
          <!-- //osResHeader -->

          <div class="widL posRe padTML padBML quiz_QnA marBL">
            <div class="widM padS amway-theme">
              <ol>
                <li class="fntH6 regular"><span class="bolder" style="color:#002f5f;">01.</span> 한국암웨이에서 암웨이-현대카드M
                  Edition2로 이용하면, M포인트와 A포인트가 동시 적립 된다?</li>
              </ol>

              <div class="radio-wrapper quiz_QnA_radio marTSM marBSM"
                style="display:flex; justify-content: space-evenly;">
                <label class="amw-radio-wrap radio-label focus ">
                  <input type="radio" name="radio-1" class="amw-global-radio" v-model="quizData.quiz01" value="true">
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">O</span>
                </label>
                <label class="amw-radio-wrap radio-label focus">
                  <input type="radio" name="radio-1" class="amw-global-radio" v-model="quizData.quiz01" value="false">
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">X</span>
                </label>
              </div>

              <ol>
                <li class="fntH6 regular"><span class="bolder" style="color:#002f5f;">02.</span> 암웨이-현대카드M Edition2를 한국암웨이에서 이용하면 M포인트와 A포인트가 전월 실적 및 한도 제한 없이 적립된다?</li>
              </ol>

              <div class="radio-wrapper quiz_QnA_radio marTSM marBSM"
                style="display:flex; justify-content: space-evenly;">
                <label class="amw-radio-wrap radio-label focus ">
                  <input type="radio" name="radio-2" class="amw-global-radio" v-model="quizData.quiz02" value="true">
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">O</span>
                </label>
                <label class="amw-radio-wrap radio-label focus">
                  <input type="radio" name="radio-2" class="amw-global-radio" v-model="quizData.quiz02" value="false">
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">X</span>
                </label>
              </div>

              <ol>
                <li class="fntH6 regular"><span class="bolder" style="color:#002f5f;">03.</span> 스마트페이는 모든 신용카드로 이용할 수
                  있다?</li>
                <li class="fntE" style="padding-top:5px; padding-left: 2em; text-indent: 0em;">*스마트페이란, 구매 즉시 총 PV/BV를 첫 달에 수령할 수 있는 최대 36개월 분할납부 방식의 구매
                  프로그램으로, 높은 할부 이자 부담을 줄일 수 있습니다.</li>
              </ol>

              <div class="radio-wrapper quiz_QnA_radio marTSM marBSM"
                style="display:flex; justify-content: space-evenly;">
                <label class="amw-radio-wrap radio-label focus ">
                  <input type="radio" name="radio-3" class="amw-global-radio" v-model="quizData.quiz03" value="true">
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">O</span>
                </label>
                <label class="amw-radio-wrap radio-label focus">
                  <input type="radio" name="radio-3" class="amw-global-radio" v-model="quizData.quiz03" value="false">
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">X</span>
                </label>
              </div>

              <div class="padTSM"
                style="display:flex; justify-content: center; gap: 0 1.3em; max-width:400px; width:95%; margin:0 auto;">
                <div style="width:45%;">
                  <a @click="layerPopOver(this, '#osLayerPop')" class="osResBtn01 txtC" style="width:100%; height:4em; padding-top:1.2em; text-align: center;">
                    응모하기
                  </a>
                </div>
                <div style="width:45%;" class="txtC">
                  <a v-on:click="hint" class="osResBtn01" style="width:100%; height:4em; padding: 0.6em 0.5em 0.6em;">힌트보기<br>
                    <span class="fntE regular">(카드 자세히보기)</span>
                  </a>
                  </div>
              </div>
            </div>
          </div>

          <!-- 공지 레이어 팝업 -->
          <div class="layerWrapper" :class="{'active': isPopup}" id="osLayerPop">
            <div class="cbox layerBox popWidM layerCenterFlex" >
              <div class="cart-popup__dialog">
                <div class="cart-popup__content payment amway-theme quiz_popUp">
                  <div class="os_noticeRes">
                    <div class="txtC padTL padBL" style="background:#ede6ff;"><img src="https://www.amway.co.kr/_ui/responsive/theme-blue/images/akl_common/quizPromo_popUp.png"
                        alt="" style="max-width:216px; width:44%;"></div>
                    <p class="fntH6 bold txtC padTM padBM">아래 개인정보 제공 및 이용 동의에 동의해 <br>주셔야 응모가 완료됩니다.</p>

                    <!-- 개인정보 수집 & 이용 동의-->
                    <p class="bold fntE widM" style="padding-bottom:5px;">개인정보 수집 &#183; 이용 동의</p>
                    <div class="widM padTM padBM" style="background:#f4f4f4;">
                      <div class="widM fntE">
                        <p class="bold">한국암웨이㈜는 암웨이-현대 제휴카드 프로모션 &ldquo;퀴즈 풀고 스타벅스 커피 받자!&rdquo; 참여를 위하여 다음과 같이 귀하의
                          개인정보를 수집, 이용합니다.</p>

                        <div class="osResNoticeList" style="padding-top:5px;">
                          <ul>
                            <li>&#x25CB; 수집하는 개인정보의 항목: 성명, 휴대 전화번호</li>
                            <li>&#x25CB; 개인정보의 수집 및 이용 목적:<br>- 이벤트 응모 고객 확정, 대상자 선정, 프로모션 혜택 등 이벤트 진행</li>
                            <li>&#x25CB; 개인정보의 보유 및 이용기간:<br><b>이벤트 종료 후 3개월 동안 보유</b> <br>*단 사진 및 영상의 경우, 이미 게재된 경우를 제외
                              합니다.</li>
                          </ul>
                        </div>

                        <div class="osResWarning">
                          <p class="padTS"><b>※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 암웨이-현대 제휴카드 프로모션 <em
                                class="disIb">&ldquo;퀴즈 풀고 스타벅스 커피 받자!&rdquo;</em> 참여가 불가합니다.</b>
                          </p>
                        </div>
                      </div>
                    </div>

                    <p class="fntE bold widM padTS">본인은 위 개인정보 수집 ∙ 이용에 동의합니다.</p>

                    <div class="amway-theme marTS">
                      <div class="radio-wrapper" style="display: flex; justify-content: center; gap: 0 2em;">
                        <label class="amw-radio-wrap radio-label focus quiz_popUp_radio">
                          <span class="amw-label-radio-text" style="margin: 0 5px 0 0;">동의</span>
                          <input type="radio" name="radio-4" class="amw-global-radio" v-model="useYnCheck.useYn01" value="true">
                          <span class="amw-radio-overlay"></span>
                        </label>
                        <label class="amw-radio-wrap radio-label focus quiz_popUp_radio">
                          <span class="amw-label-radio-text" style="margin: 0 5px 0 0;">미동의</span>
                          <input type="radio" name="radio-4" class="amw-global-radio" v-model="useYnCheck.useYn01" value="false">
                          <span class="amw-radio-overlay"></span>
                        </label>
                      </div>
                    </div>

                    <!-- 개인정보 제3자 제공 동의-->
                    <p class="bold fntE widM marTSM" style="padding-bottom:5px;">개인정보 제3자 제공 동의</p>
                    <div class="widM padTM padBM" style="background:#f4f4f4;">
                      <div class="widM fntE">
                        <p class="bold">한국암웨이㈜는 암웨이-현대 제휴카드 프로모션 &ldquo;퀴즈 풀고, 스타벅스 커피 받자!&rdquo; 참여를 위하여 다음과 같이 귀하의
                          개인정보를 제3자에 대하여 제공합니다.</p>

                        <div class="osResNoticeList" style="padding-top:5px;">
                          <ul>
                            <li>&#x25CB; 개인정보를 제공 받는 자: (주)현대카드</li>
                            <li>&#x25CB; 개인정보를 제공 받는 자의 개인정보 이용 목적:<br>- 이벤트 응모 고객 확정, 대상자 선정, 프로모션 혜택
                              등 이벤트 진행</li>
                            <li>&#x25CB; 제공하는 개인정보의 항목: 성명, 휴대 전화번호</li>
                            <li>&#x25CB; 개인정보를 제공받는 자의 개인정보 보유 및 이용기간 :<br>이벤트 종료 후 3개월 동안 보유</li>
                          </ul>
                        </div>

                        <div class="osResWarning">
                          <p class="padTS"><b>※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 암웨이-현대 제휴카드 프로모션 <em
                                class="disIb">&ldquo;퀴즈 풀고, 스타벅스 커피 받자!&rdquo;</em> 참여가 불가합니다.</b>
                          </p>
                        </div>
                      </div>
                    </div>

                    <p class="fntE bold widM padTS">본인은 위 개인정보 제3자 제공에 동의합니다.</p>

                    <div class="amway-theme marTS marBSM">
                      <div class="radio-wrapper" style="display: flex; justify-content: center; gap: 0 2em;">
                        <label class="amw-radio-wrap radio-label focus quiz_popUp_radio">
                          <span class="amw-label-radio-text" style="margin: 0 5px 0 0;">동의</span>
                          <input type="radio" name="radio-5" class="amw-global-radio" v-model="useYnCheck.useYn02" value="true">
                          <span class="amw-radio-overlay"></span>
                        </label>
                        <label class="amw-radio-wrap radio-label focus quiz_popUp_radio">
                          <span class="amw-label-radio-text" style="margin: 0 5px 0 0;">미동의</span>
                          <input type="radio" name="radio-5" class="amw-global-radio" v-model="useYnCheck.useYn02" value="false">
                          <span class="amw-radio-overlay"></span>
                        </label>
                      </div>
                    </div>

                    <div class="txtC marBML"><a href="#" id="close_btn" v-on:click="checkYn" class="bt-akl-blue btn_close quiz_popUp_btn">확인</a></div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <!-- //공지 레이어 팝업 -->
        </div>
      </div>
      <!-- //os_noticeRes -->
      <!-- //제휴카드 프로모션(퀴즈응모) 공지 끝 -->


    </div><!-- //.bod-view-txt -->
  </div><!-- //.akl -->

</template>


<style scoped>
@import '../font_kr.css';
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/main_new.css');
@import url('https://www.amway.co.kr/wro/blue_responsive.css');
@import url('https://www.amway.co.kr/wro/addons_responsive.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/content_res_all.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/uiux_res_all.css');

.os_noticeRes.quiz_wrap{padding-bottom:1em;}
.os_noticeRes.quiz_wrap .osResHeader {background: #defcff url(https://www.amway.co.kr/_ui/responsive/theme-blue/images/akl_common/quizPromo_bg.jpg) no-repeat top center / 1376px auto; }
.os_noticeRes .quiz_QnA {background: #fff; margin-top: -4em; z-index: 2; border: 2px solid #e3e3e3; border-radius: 25px;}
    
.os_noticeRes .quiz_QnA ol li{padding-left:1.7em; text-indent: -1.7em;}
.akl .radio-wrapper.quiz_QnA_radio label .amw-label-radio-text {font-size: 18px; position: relative; top: -3px;}
.akl .amway-theme .radio-wrapper.quiz_QnA_radio input.amw-global-radio:checked+.amw-radio-overlay:before {background: #002f5f;}
.akl .radio-wrapper.quiz_QnA_radio .radio-label+.radio-label {margin-left: 0 !important;}

/* popup */
.amway-theme.quiz_popUp .amw-radio-overlay{width:16px; height:16px; position: inherit;}
.amway-theme.quiz_popUp input.amw-global-radio:checked+.amw-radio-overlay:before{width:8px; height:8px;}
.akl .amway-theme.quiz_popUp input.amw-global-radio:checked + .amw-radio-overlay:before{background:#002f5f;}
.akl .amway-theme.quiz_popUp label.amw-radio-wrap .amw-radio-overlay{top:3px;}
.akl .bt-akl-blue.quiz_popUp_btn.btn_close{color:#fff;}
.akl .bt-akl-blue.quiz_popUp_btn.btn_close:hover{color:#002f5f;}
.akl .wrapper-memb-join .amw-radio-wrap.radio-label.quiz_popUp_radio{padding-left:0;}
.akl .radio-label.quiz_popUp_radio + .radio-label{margin-left:0 !important;}


@media screen and (max-width:639px) {
    .os_noticeRes.quiz_wrap .osResHeader {background-size: cover; padding-bottom:90px;}
    .os_noticeRes .quiz_QnA .widS{width:90%;}
}


.layerCenterFlex { 
  justify-content: center ;
  align-items: center;
  display: flex !important;
  min-height: 100vh;
  position: relative;
  min-width: 300px;
  max-width: 960px;
}
</style>

<script>


import axios from 'axios';
import querystring from 'querystring'

export default {

  data : () => {
    return {
      isPopup : true,
      aboInfo: Object,
      abcLocale: String,
      abcLocalName: String,
      agrees: Boolean,
      applyResult: Number,
      au_token: Object,
      current_time : null,
      count : null,

      token_body: {
        client_id: process.env.OCC_AUTH_CLIENT_ID,
        client_secret: process.env.OCC_AUTH_CLIENT_SECRET,
        grant_type: process.env.OCC_AUTH_GRANT_TYPE
      },
      ready : false,

      quizData : {
        quiz01 : null,
        quiz02 : null,
        quiz03 : null
      },
      useYnCheck : {
        useYn01   : null,
        useYn02   : null
      }
      
    }
  },

  methods : {
    init : async function () {
      this.aboInfo = {aboNo : '', aboName : '' , aboPhone : ''}
      this.abcLocale = ''
      this.abcLocalName = ''
      this.agrees = false
      this.applyResult = -1
      this.au_token = ''
      await this.checkLogin() // 로그인 체크(회원번호,이름)
    },
    
    // 로그인 체크
    checkLogin: async function () {
      await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
      ).then(response => {
        if (response.data.header.status === 'ERROR') { // login fail
          window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
          // login success
          this.aboInfo.aboNo = atob(response.data.customerUid)
          this.aboInfo.aboName = response.data.name
        }
      }).catch(ex => {
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        
      })
    },
      
    // 응모하기 버튼 이벤트 
    layerPopOver() {
      try {
        if(this.quizData.quiz01 == null || this.quizData.quiz02 == null || this.quizData.quiz03 == null){
          alert('체크박스를 모두 클릭해 주세요')
          return;
        } else if (!this.isCorrect()) {
          alert('오답이 있습니다. 힌트보기를 통해 정답을 확인하세요.')
          return;
        }else{
          document.getElementById('osLayerPop').style = 'display:block; z-index: 10000; background: rgba(0,0,0,0.8);'
        }
      }catch (error) {
        console.log('Error >>> ' + error)
      }
    
    },
    // 정답 체크 
    isCorrect: function () { 
      if(this.quizData.quiz01 == 'true' && this.quizData.quiz02 == 'true' && this.quizData.quiz03 == 'false'){
        return true; 
      } else { 
        return false;
      }
    }, 

    // 약관 동의 여부 체크 
    isAgree: function () {
      if (this.useYnCheck.useYn01 !== 'true' || this.useYnCheck.useYn02 !== 'true') {
        alert('개인정보 수집 이용 동의 후 응모하실 수 있습니다.')
        return false;
      } else { 
        return true; 
      }
    }, 

    // 응모하기 버튼 이벤트 
    checkYn : function () {
      try {
        if (this.isAgree()) {
          this.apply();
          document.getElementById('osLayerPop').style = 'display:none;'
        } 
      } catch (error) {

      }
    },
    

    // 현대카드 힌트보기 새창 열기 
    hint : function () {
      window.open('https://www.amway.co.kr/notifications/card-benefit')
    },

    // 현재시간 가져오기
    time : function () {

      const date = new Date();
      // 년 , 월 , 일 
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      // 시 , 분 , 초
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);
      
      const dateStr = year + '-' + month + '-' + day;
      const timeStr = hours + ':' + minutes + ':' + seconds;

      const curTime = dateStr+':'+timeStr;

      return curTime
    },

    // 응모하기
    apply: async function () {
      await axios.post(process.env.AWS_GATEWAY_URL_V2+'/event-admin/affiliate-card-entry-info',
      {
        time      : this.current_time = this.time(),
        abo_number: this.aboInfo.aboNo,
        quiz_chk01: this.quizData.quiz01,
        quiz_chk02: this.quizData.quiz02,
        quiz_chk03: this.quizData.quiz03,
        use_yn01: this.useYnCheck.useYn01,
        use_yn02: this.useYnCheck.useYn02
      }).then(response => {
        let total = response.data.count.value
        // 접수마감 체크 (1만명이후 체크) 
        
        if(total > 10000){
          alert('이벤트 접수가 마감되었습니다. 많은 성원에 감사드립니다.')
          return;
        }
         
        // 응모가능한 날짜 체크
        if(response.data.entry_info.getResult === 'N'){
            alert('현재는 응모할 수 있는 기간이 아닙니다. \n본 이벤트는 2022-09-01부터 2022-10-31까지 진행됩니다.')
            return;
        }
        // 접수 체크
        if(response.data.results.status === 'SUCCESS'){
          alert('축하드립니다 이벤트에 성공적으로 접수되었습니다.')
          return;
        }

        // 중복 체크
        if(response.data.results.status === 'EXIST'){
          alert('본 이벤트는 총 1회만 접수가 가능합니다.')
          return;
        }
      }).catch(error => {
        console.log(error)
      })

      }
    }, // end of setAnswerList function
    mounted : function () {
      window.setTimeout(() => {
      this.ready = true
      this.init()
    }, 500)

    } 
  }
</script>


// WEBPACK FOOTER //
// src/views/affiliatecard/quiz/affiliateCardQuiz.vue